<div class="cp-panel" *ngIf="row">
  <section class="cp-card">
    <div class="cp-card__header">
      <span class="cp-card__title"><mat-icon>credit_card</mat-icon> Disponibilidad</span>
      <app-status-pill *ngIf="row.connected === true" label="Banco conectado" variant="success"></app-status-pill>
      <app-status-pill *ngIf="row.connected === false" label="Sin conexión bancaria" variant="neutral"></app-status-pill>
    </div>

    <div class="cp-kpis">
      <div class="cp-kpi">
        <span class="cp-kpi__label">Límite</span>
        <span class="cp-kpi__value">{{ limit | number:'1.2-2' }} €</span>
      </div>
      <div class="cp-kpi">
        <span class="cp-kpi__label">Dispuesto</span>
        <span class="cp-kpi__value">{{ (row.dispuesto || 0) | number:'1.2-2' }} €</span>
      </div>
      <div class="cp-kpi cp-kpi--accent">
        <span class="cp-kpi__label">Disponible</span>
        <span class="cp-kpi__value">{{ (row.disponible || 0) | number:'1.2-2' }} €</span>
      </div>
    </div>

    <div class="cp-progress" *ngIf="limit > 0">
      <div class="cp-progress__bar">
        <div class="cp-progress__fill" [class.cp-progress__fill--over]="overLimit" [style.width.%]="percent"></div>
      </div>
      <div class="cp-progress__legend">
        <span>Utilizado <strong>{{ used | number:'1.2-2' }} €</strong></span>
        <span><strong>{{ percent | number:'1.0-0' }} %</strong> del límite</span>
      </div>
    </div>

    <div class="cp-lines">
      <div class="cp-line">
        <span class="cp-line__label">Banco</span>
        <span class="cp-line__value">{{ row.banco || '—' }}</span>
      </div>
      <div class="cp-line">
        <span class="cp-line__label">IBAN</span>
        <span class="cp-line__value">{{ row.iban || '—' }}</span>
      </div>
      <div class="cp-line">
        <span class="cp-line__label">BIC / SWIFT</span>
        <span class="cp-line__value">{{ row.bic || '—' }}</span>
      </div>
      <div class="cp-line">
        <span class="cp-line__label">Cuenta contable</span>
        <span class="cp-line__value">{{ row.accountingModelsNumber || '—' }}</span>
      </div>
    </div>
  </section>

  <section class="cp-card">
    <div class="cp-card__header">
      <span class="cp-card__title"><mat-icon>compare_arrows</mat-icon> Operaciones del ejercicio</span>
    </div>

    <app-loading-state *ngIf="loading" [compact]="true" message="Cargando operaciones de la póliza…"></app-loading-state>

    <div class="cp-empty cp-empty--error" *ngIf="!loading && error">
      <mat-icon>error</mat-icon>
      <span>No se pudieron cargar las operaciones de la póliza.</span>
      <button mat-stroked-button class="cf-btn" (click)="retry()">
        <mat-icon>refresh</mat-icon> Reintentar
      </button>
    </div>

    <ng-container *ngIf="!loading && !error">
      <div class="cp-block" *ngFor="let block of blocks; trackBy: trackByBlock">
        <div class="cp-block__header">
          <span class="cp-block__title"><mat-icon>{{ block.icon }}</mat-icon> {{ block.title }}</span>
          <span class="cp-block__side">
            <span class="cp-block__summary" *ngIf="block.count > 0">
              {{ block.count }} · <strong>{{ block.total | number:'1.2-2' }} €</strong>
            </span>
            <button mat-stroked-button type="button" class="cf-btn cf-btn--primary cp-add" (click)="add(block)">
              <mat-icon>add</mat-icon> Añadir
            </button>
          </span>
        </div>

        <div class="cp-moves" *ngIf="block.lines.length">
          <div class="cp-move" *ngFor="let line of block.lines; trackBy: trackByUid">
            <span class="cp-move__date">{{ line.date | date:'dd/MM/yyyy' }}</span>
            <span class="cp-move__info">
              <span class="cp-move__concept" [title]="line.concept">{{ line.concept }}</span>
              <span class="cp-move__meta" *ngIf="line.meta" [title]="line.meta">{{ line.meta }}</span>
            </span>
            <span class="cp-move__amount">{{ line.amount | number:'1.2-2' }} €</span>
            <span class="cp-move__actions">
              <button type="button" class="cp-icon-btn" (click)="editLine(block, line)" title="Editar" [attr.aria-label]="'Editar ' + block.singular">
                <mat-icon>edit</mat-icon>
              </button>
              <button type="button" class="cp-icon-btn cp-icon-btn--danger" (click)="deleteLine(block, line)" title="Eliminar" [attr.aria-label]="'Eliminar ' + block.singular">
                <mat-icon>delete</mat-icon>
              </button>
            </span>
          </div>
          <button type="button" class="cp-more" *ngIf="block.count > maxLines" (click)="manage(block)">
            Ver los {{ block.count }} movimientos <mat-icon>chevron_right</mat-icon>
          </button>
        </div>

        <div class="cp-block__empty" *ngIf="!block.lines.length">{{ block.emptyText }}</div>
      </div>
    </ng-container>
  </section>
</div>
